<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="3"></v-col>
        <v-col cols="12" sm="6">
          <v-btn
              color="primary"
              dark
              class="ml-auto ma-3"
              style="width:100%"
              @click="uploadFile"
              v-if="isFilesLoaded"
          >
            Upload file
            <v-icon class="ml-2" small>fas fa-upload</v-icon>
          </v-btn>
          <file-pond
              name="files"
              ref="pond"
              label-idle="Drop files here or <span class='filepond--label-action'>Browse</span>"
              accepted-file-types="text/csv, .csv"
              @init="handleFilePondInit"
              @addfile="handleFileAdded"
              @removefile="handleFileRemoved"
          />
        </v-col>
        <v-col cols="12" sm="3"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Sr.</th>
                <th class="text-left">Project Name</th>
                <th class="text-left">Plot Area Square Meter</th>
                <th class="text-left">Plot Area Square Feet</th>
                <th class="text-left">Villas</th>
                <th class="text-left">Townhouses</th>
                <th class="text-left">Apartments</th>
                <th class="text-left">Total Units</th>
                <th class="text-left">Completion Status</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(summary, i) in summaries"
                  :key="i"
              >
                <td>{{ i + 1 }}</td>
                <td>{{ summary.project_name }}</td>
                <td>{{ summary.plot_area_sqm }}</td>
                <td>{{ summary.plot_area_sqft }}</td>
                <td>{{ summary.villas }}</td>
                <td>{{ summary.townhouses }}</td>
                <td>{{ summary.apartments }}</td>
                <td>{{ summary.total_units }}</td>
                <td>{{ summary.completion_status }}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr class="font-weight-bold">
                <td colspan="2" class="text-right">Total:</td>
                <td>{{ addTSBV(totalPlotAreaSqm) }}</td>
                <td>{{ addTSBV(totalPlotAreaSft) }}</td>
                <td>{{ addTSBV(totalVillas) }}</td>
                <td>{{ addTSBV(totalTownhouses) }}</td>
                <td>{{ addTSBV(totalApartments) }}</td>
                <td>{{ addTSBV(totalUnits) }}</td>
              </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  name: 'development-summary',
  props: ['development'],
  components: {
    FilePond
  },
  data() {
    return {
      isFilesLoaded: false,
      totalPlotAreaSqm: this.development.summary.total_plsm,
      totalPlotAreaSft: this.development.summary.total_plsf,
      totalVillas: this.development.summary.total_villas,
      totalTownhouses: this.development.summary.total_townhouses,
      totalApartments: this.development.summary.total_apartments,
      totalUnits: this.development.summary.total_units_sum,
      summaries: this.development.summary.summaries
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleFileAdded() {
      this.isFilesLoaded = true;
    },
    handleFileRemoved() {
      this.isFilesLoaded = false;
    },
    handleFilePondInit() {
    },
    uploadFile() {
      const formData = new FormData();

      // Get the actual file object from FilePond
      const pondFiles = this.$refs.pond.getFiles();
      if (pondFiles.length > 0) {
        const actualFile = pondFiles[0].file; // Access the actual File object

        formData.append("file", actualFile, actualFile.name);
        formData.append("dev_id", this.development.id);

        this.$store.dispatch("upload_development_summary_file", formData).then(data => {
          this.$refs.pond.removeFiles();
          this.isFilesLoaded = false;
          this.totalPlotAreaSqm = data.records.total_plsm
          this.totalPlotAreaSft = data.records.total_plsf
          this.totalVillas = data.records.total_villas
          this.totalTownhouses = data.records.total_townhouses
          this.totalApartments = data.records.total_apartments
          this.totalUnits = data.records.total_units_sum
          this.summaries = data.records.summaries
        });
      }
    }
  },
  computed: {}
};
</script>